/* eslint-disable @typescript-eslint/indent */
import { ReactNode } from 'react'
import styled from 'styled-components'
import useResizeObserver from 'use-resize-observer'

type IProps = {
  children: ReactNode
}

export const AppLayout = ({ children }: IProps) => {
  const { ref, width = 1, height = 1 } = useResizeObserver<HTMLDivElement>()

  return (
    <div style={{ height: '100%' }} ref={ref}>
      <AppLayoutStyled sizeRatio={width / height}>
        <Container>{children}</Container>
      </AppLayoutStyled>
    </div>
  )
}

const Container = styled.div`
  max-width: 1024px;
  margin: 0 auto;
`

const AppLayoutStyled = styled.div<{ sizeRatio: number }>`
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({ sizeRatio }) => `
    --first-gradient-coords: -6% 37%;
    --second-gradient-coords: 107% 59%;

    background-image: radial-gradient(circle closest-corner at var(--first-gradient-coords), rgba(40,72,122, 0.85), transparent),
      radial-gradient(circle closest-corner at var(--second-gradient-coords), rgba(138,41,129, 0.7), transparent);
  
    ${
      sizeRatio < 1.6 && sizeRatio >= 1
        ? `
      --first-gradient-coords: -8% 32%;
      --second-gradient-coords: 110% 67%;
    `
        : ''
    }

    ${
      sizeRatio < 1
        ? `
      --first-gradient-coords: -5% 13%;
      --second-gradient-coords: 140% 35%;
    `
        : ''
    }
  `}
`
